import { createRoute, redirect } from "@tanstack/react-router";

import { lazyWithRetry } from "@shared/lib/lazy";

import { renderProtectedRoute } from "@app/router/routeElements";
import { rootRoute } from "@app/router/rootRoute";

const aiIndex = lazyWithRetry(() => import("./routes/index"));

const aiIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/ai",
  validateSearch: (
    search: Record<string, unknown>,
  ): { preferences?: boolean } => ({
    preferences: search.preferences === true || search.preferences === "true",
  }),
  component: () => renderProtectedRoute(aiIndex, { requirePerms: ["ai:read"] }),
});

const aiMemoryRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/ai/memory",
  beforeLoad: () => {
    throw redirect({ to: "/ai", search: { preferences: true }, replace: true });
  },
});

const aiPoliciesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/ai/policies",
  beforeLoad: () => {
    throw redirect({ to: "/ai", replace: true });
  },
});

export const aiRouteTree = [aiIndexRoute, aiMemoryRoute, aiPoliciesRoute];
